/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DisableBankAccountGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type DisableBankAccountRequest = {
  accountID: string;
  bankAccountID: string;
};

export type DisableBankAccountResponse = {
  headers: { [k: string]: Array<string> };
};

/** @internal */
export const DisableBankAccountGlobals$inboundSchema: z.ZodType<
  DisableBankAccountGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type DisableBankAccountGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const DisableBankAccountGlobals$outboundSchema: z.ZodType<
  DisableBankAccountGlobals$Outbound,
  z.ZodTypeDef,
  DisableBankAccountGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function disableBankAccountGlobalsToJSON(
  disableBankAccountGlobals: DisableBankAccountGlobals,
): string {
  return JSON.stringify(
    DisableBankAccountGlobals$outboundSchema.parse(disableBankAccountGlobals),
  );
}
export function disableBankAccountGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<DisableBankAccountGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DisableBankAccountGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DisableBankAccountGlobals' from JSON`,
  );
}

/** @internal */
export const DisableBankAccountRequest$inboundSchema: z.ZodType<
  DisableBankAccountRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  bankAccountID: z.string(),
});
/** @internal */
export type DisableBankAccountRequest$Outbound = {
  accountID: string;
  bankAccountID: string;
};

/** @internal */
export const DisableBankAccountRequest$outboundSchema: z.ZodType<
  DisableBankAccountRequest$Outbound,
  z.ZodTypeDef,
  DisableBankAccountRequest
> = z.object({
  accountID: z.string(),
  bankAccountID: z.string(),
});

export function disableBankAccountRequestToJSON(
  disableBankAccountRequest: DisableBankAccountRequest,
): string {
  return JSON.stringify(
    DisableBankAccountRequest$outboundSchema.parse(disableBankAccountRequest),
  );
}
export function disableBankAccountRequestFromJSON(
  jsonString: string,
): SafeParseResult<DisableBankAccountRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DisableBankAccountRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DisableBankAccountRequest' from JSON`,
  );
}

/** @internal */
export const DisableBankAccountResponse$inboundSchema: z.ZodType<
  DisableBankAccountResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
  });
});
/** @internal */
export type DisableBankAccountResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
};

/** @internal */
export const DisableBankAccountResponse$outboundSchema: z.ZodType<
  DisableBankAccountResponse$Outbound,
  z.ZodTypeDef,
  DisableBankAccountResponse
> = z.object({
  headers: z.record(z.array(z.string())),
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
  });
});

export function disableBankAccountResponseToJSON(
  disableBankAccountResponse: DisableBankAccountResponse,
): string {
  return JSON.stringify(
    DisableBankAccountResponse$outboundSchema.parse(disableBankAccountResponse),
  );
}
export function disableBankAccountResponseFromJSON(
  jsonString: string,
): SafeParseResult<DisableBankAccountResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DisableBankAccountResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DisableBankAccountResponse' from JSON`,
  );
}
